var _classCallCheck = require("/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/createClass.js");
var _get = require("/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/get.js");
var _inherits = require("/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _wrapNativeSuper = require("/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
var _toConsumableArray = require("/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _slicedToArray = require("/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _defineProperty = require("/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/defineProperty.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
require("core-js/modules/esnext.global-this.js");
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self)["react-horizontal-scrolling-menu"] = {}, e.React);
}(this, function (e, t) {
  "use strict";

  function n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }
  var r = n(t);
  !function (e, t) {
    void 0 === t && (t = {});
    var n = t.insertAt;
    if (e && "undefined" != typeof document) {
      var r = document.head || document.getElementsByTagName("head")[0],
        o = document.createElement("style");
      o.type = "text/css", "top" === n && r.firstChild ? r.insertBefore(o, r.firstChild) : r.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
    }
  }(".react-horizontal-scrolling-menu--scroll-container {\n  display: flex;\n  height: max-content;\n  overflow-y: hidden;\n  position: relative;\n  width: 100%;\n}\n\n.react-horizontal-scrolling-menu--scroll-container.rtl {\n  direction: rtl;\n}\n\n.react-horizontal-scrolling-menu--inner-wrapper {\n  display: flex;\n  overflow-y: hidden;\n}\n\n.react-horizontal-scrolling-menu--wrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.react-horizontal-scrolling-menu--header,\n.react-horizontal-scrolling-menu--footer {\n  width: 100%;\n}\n\n.react-horizontal-scrolling-menu--arrow-left,\n.react-horizontal-scrolling-menu--arrow-right {\n  display: flex;\n}\n");
  var o = "react-horizontal-scrolling-menu",
    l = "-separator",
    i = "".concat(o, "-").concat(l),
    a = "".concat(o, "--item"),
    s = "".concat(o, "--scroll-container"),
    u = "".concat(o, "--wrapper"),
    d = "".concat(o, "--inner-wrapper"),
    c = "".concat(o, "--header"),
    f = "".concat(o, "--arrow-left"),
    v = "".concat(o, "--arrow-right"),
    m = "".concat(o, "--footer"),
    h = "itemId",
    p = "data-key",
    g = "data-index";
  var b = Object.freeze({
    __proto__: null,
    rootClassName: o,
    separatorString: l,
    separatorClassName: i,
    itemClassName: a,
    scrollContainerClassName: s,
    wrapperClassName: u,
    innerWrapperClassName: d,
    headerClassName: c,
    arrowLeftClassName: f,
    arrowRightClassName: v,
    footerClassName: m,
    id: h,
    dataKeyAttribute: p,
    dataIndexAttribute: g
  });
  function y(_ref) {
    var _ref$className = _ref.className,
      e = _ref$className === void 0 ? "" : _ref$className,
      t = _ref.children,
      _ref$onScroll = _ref.onScroll,
      n = _ref$onScroll === void 0 ? function () {} : _ref$onScroll,
      o = _ref.scrollRef;
    var l = r.default.useMemo(function () {
      return "".concat(s, " ").concat(e);
    }, [e]);
    return r.default.createElement("div", {
      className: l,
      onScroll: n,
      ref: o
    }, t);
  }
  var w = r.default.memo(function (_ref2) {
    var _Object$assign;
    var e = _ref2.className,
      t = _ref2.id,
      n = _ref2.index,
      o = _ref2.refs;
    var l = r.default.useRef(null);
    return o[n] = l, r.default.createElement("div", Object.assign({
      className: e
    }, (_Object$assign = {}, _defineProperty(_Object$assign, p, t), _defineProperty(_Object$assign, g, n), _Object$assign), {
      ref: l
    }));
  });
  var E = r.default.memo(function (_ref3) {
    var _Object$assign2;
    var e = _ref3.children,
      t = _ref3.className,
      n = _ref3.id,
      o = _ref3.index,
      l = _ref3.refs;
    var i = r.default.useRef(null);
    return l[String(o)] = i, r.default.createElement("div", Object.assign({
      className: t
    }, (_Object$assign2 = {}, _defineProperty(_Object$assign2, p, n), _defineProperty(_Object$assign2, g, o), _Object$assign2), {
      ref: i
    }), e);
  });
  function x(e) {
    return "object" == typeof e && null != e && 1 === e.nodeType;
  }
  function C(e, t) {
    return (!t || "hidden" !== e) && "visible" !== e && "clip" !== e;
  }
  function I(e, t) {
    if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
      var n = getComputedStyle(e, null);
      return C(n.overflowY, t) || C(n.overflowX, t) || function (e) {
        var t = function (e) {
          if (!e.ownerDocument || !e.ownerDocument.defaultView) return null;
          try {
            return e.ownerDocument.defaultView.frameElement;
          } catch (e) {
            return null;
          }
        }(e);
        return !!t && (t.clientHeight < e.scrollHeight || t.clientWidth < e.scrollWidth);
      }(e);
    }
    return !1;
  }
  function N(e, t, n, r, o, l, i, a) {
    return l < e && i > t || l > e && i < t ? 0 : l <= e && a <= n || i >= t && a >= n ? l - e - r : i > t && a < n || l < e && a > n ? i - t + o : 0;
  }
  var S,
    M = function M(e, t) {
      var n = window,
        r = t.scrollMode,
        o = t.block,
        l = t.inline,
        i = t.boundary,
        a = t.skipOverflowHiddenElements,
        s = "function" == typeof i ? i : function (e) {
          return e !== i;
        };
      if (!x(e)) throw new TypeError("Invalid target");
      for (var u, d, c = document.scrollingElement || document.documentElement, f = [], v = e; x(v) && s(v);) {
        if ((v = null == (d = (u = v).parentElement) ? u.getRootNode().host || null : d) === c) {
          f.push(v);
          break;
        }
        null != v && v === document.body && I(v) && !I(document.documentElement) || null != v && I(v, a) && f.push(v);
      }
      for (var m = n.visualViewport ? n.visualViewport.width : innerWidth, h = n.visualViewport ? n.visualViewport.height : innerHeight, p = window.scrollX || pageXOffset, g = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, w = b.width, E = b.top, C = b.right, S = b.bottom, M = b.left, $ = "start" === o || "nearest" === o ? E : "end" === o ? S : E + y / 2, W = "center" === l ? M + w / 2 : "end" === l ? C : M, k = [], O = 0; O < f.length; O++) {
        var T = f[O],
          V = T.getBoundingClientRect(),
          R = V.height,
          j = V.width,
          A = V.top,
          B = V.right,
          H = V.bottom,
          L = V.left;
        if ("if-needed" === r && E >= 0 && M >= 0 && S <= h && C <= m && E >= A && S <= H && M >= L && C <= B) return k;
        var P = getComputedStyle(T),
          z = parseInt(P.borderLeftWidth, 10),
          D = parseInt(P.borderTopWidth, 10),
          _ = parseInt(P.borderRightWidth, 10),
          F = parseInt(P.borderBottomWidth, 10),
          X = 0,
          Y = 0,
          q = "offsetWidth" in T ? T.offsetWidth - T.clientWidth - z - _ : 0,
          J = "offsetHeight" in T ? T.offsetHeight - T.clientHeight - D - F : 0,
          U = "offsetWidth" in T ? 0 === T.offsetWidth ? 0 : j / T.offsetWidth : 0,
          K = "offsetHeight" in T ? 0 === T.offsetHeight ? 0 : R / T.offsetHeight : 0;
        if (c === T) X = "start" === o ? $ : "end" === o ? $ - h : "nearest" === o ? N(g, g + h, h, D, F, g + $, g + $ + y, y) : $ - h / 2, Y = "start" === l ? W : "center" === l ? W - m / 2 : "end" === l ? W - m : N(p, p + m, m, z, _, p + W, p + W + w, w), X = Math.max(0, X + g), Y = Math.max(0, Y + p);else {
          X = "start" === o ? $ - A - D : "end" === o ? $ - H + F + J : "nearest" === o ? N(A, H, R, D, F + J, $, $ + y, y) : $ - (A + R / 2) + J / 2, Y = "start" === l ? W - L - z : "center" === l ? W - (L + j / 2) + q / 2 : "end" === l ? W - B + _ + q : N(L, B, j, z, _ + q, W, W + w, w);
          var G = T.scrollLeft,
            Q = T.scrollTop;
          $ += Q - (X = Math.max(0, Math.min(Q + X / K, T.scrollHeight - R / K + J))), W += G - (Y = Math.max(0, Math.min(G + Y / U, T.scrollWidth - j / U + q)));
        }
        k.push({
          el: T,
          top: X,
          left: Y
        });
      }
      return k;
    };
  function $(e) {
    return e === Object(e) && 0 !== Object.keys(e).length;
  }
  function W(e, t) {
    var n = e.isConnected || e.ownerDocument.documentElement.contains(e);
    if ($(t) && "function" == typeof t.behavior) return t.behavior(n ? M(e, t) : []);
    if (n) {
      var r = function (e) {
        return !1 === e ? {
          block: "end",
          inline: "nearest"
        } : $(e) ? e : {
          block: "start",
          inline: "nearest"
        };
      }(t);
      return function (e, t) {
        void 0 === t && (t = "auto");
        var n = ("scrollBehavior" in document.body.style);
        e.forEach(function (e) {
          var r = e.el,
            o = e.top,
            l = e.left;
          r.scroll && n ? r.scroll({
            top: o,
            left: l,
            behavior: t
          }) : (r.scrollTop = o, r.scrollLeft = l);
        });
      }(M(e, r), r.behavior);
    }
  }
  var k = function k() {
    return S || (S = "performance" in window ? performance.now.bind(performance) : Date.now), S();
  };
  function O(e) {
    var t = k(),
      n = Math.min((t - e.startTime) / e.duration, 1),
      r = e.ease(n),
      o = e.startX + (e.x - e.startX) * r,
      l = e.startY + (e.y - e.startY) * r;
    e.method(o, l), o !== e.x || l !== e.y ? requestAnimationFrame(function () {
      return O(e);
    }) : e.cb();
  }
  function T(e, t, n, r, o, l) {
    var i, a, s, u;
    void 0 === r && (r = 600), void 0 === o && (o = function o(e) {
      return 1 + --e * e * e * e * e;
    }), i = e, a = e.scrollLeft, s = e.scrollTop, u = function u(t, n) {
      e.scrollLeft = Math.ceil(t), e.scrollTop = Math.ceil(n);
    }, O({
      scrollable: i,
      method: u,
      startTime: k(),
      startX: a,
      startY: s,
      x: t,
      y: n,
      duration: r,
      ease: o,
      cb: l
    });
  }
  var V = function V(e) {
    return e && !e.behavior || "smooth" === e.behavior;
  };
  var R = function R(e, t) {
    var n = t || {};
    return V(n) ? W(e, {
      block: n.block,
      inline: n.inline,
      scrollMode: n.scrollMode,
      boundary: n.boundary,
      behavior: function behavior(e) {
        return Promise.all(e.reduce(function (e, t) {
          var r = t.el,
            o = t.left,
            l = t.top,
            i = r.scrollLeft,
            a = r.scrollTop;
          return i === o && a === l ? e : [].concat(e, [new Promise(function (e) {
            return T(r, o, l, n.duration, n.ease, function () {
              return e({
                el: r,
                left: [i, o],
                top: [a, l]
              });
            });
          })]);
        }, []));
      }
    }) : Promise.resolve(W(e, t));
  };
  var j = function j(e) {
    return Object.values(e).map(function (e) {
      return e.current;
    }).filter(Boolean);
  };
  function A(e, t, n, r, o, l) {
    var i;
    var a = (null === (i = null == e ? void 0 : e.entry) || void 0 === i ? void 0 : i.target) || e,
      s = t || "smooth";
    if (a) return l ? null == a ? void 0 : a.scrollIntoView({
      behavior: s,
      inline: n || "end",
      block: r || "nearest"
    }) : R(a, Object.assign({
      behavior: s,
      inline: n || "end",
      block: r || "nearest",
      duration: 500
    }, o));
  }
  var B = function B(e) {
      return document.querySelector("[".concat(p, "='").concat(e, "']"));
    },
    H = function H(e) {
      return document.querySelector("[".concat(g, "='").concat(e, "']"));
    };
  function L(e) {
    return r.default.isValidElement(e) && e || "function" == typeof e && r.default.createElement(e, null) || null;
  }
  var P = function P(e) {
      return e.filter(function (e) {
        return !new RegExp(".*".concat(l, "$")).test(e);
      });
    },
    z = function z(e) {
      var t;
      return String((null === (t = null == e ? void 0 : e.props) || void 0 === t ? void 0 : t[h]) || String((null == e ? void 0 : e.key) || "").replace(/^\.\$/, ""));
    };
  function D(_ref4) {
    var e = _ref4.children,
      _ref4$itemClassName = _ref4.itemClassName,
      t = _ref4$itemClassName === void 0 ? "" : _ref4$itemClassName,
      n = _ref4.refs,
      _ref4$separatorClassN = _ref4.separatorClassName,
      o = _ref4$separatorClassN === void 0 ? "" : _ref4$separatorClassN;
    var s = r.default.Children.toArray(e).filter(Boolean),
      u = s.length,
      d = r.default.useMemo(function () {
        return "".concat(a, " ").concat(t);
      }, [t]),
      c = r.default.useMemo(function () {
        return "".concat(i, " ").concat(o);
      }, [o]);
    return r.default.createElement(r.default.Fragment, null, s.map(function (e, t) {
      var o = z(e),
        i = o + l,
        a = t + 1 === u;
      return [r.default.createElement(E, {
        className: d,
        id: o,
        key: "menuItem__" + o,
        refs: n,
        index: t
      }, e), !a && r.default.createElement(w, {
        className: c,
        id: i,
        refs: n,
        key: i,
        index: t + .1
      })];
    }));
  }
  var _ = "undefined" != typeof window ? r.default.useLayoutEffect : r.default.useEffect;
  function F(_ref5) {
    var e = _ref5.items,
      t = _ref5.itemsChanged,
      n = _ref5.refs,
      o = _ref5.options;
    var l = r.default.useRef(),
      _r$default$useState = r.default.useState([]),
      _r$default$useState2 = _slicedToArray(_r$default$useState, 2),
      i = _r$default$useState2[0],
      a = _r$default$useState2[1],
      s = r.default.useRef(+setTimeout(function () {}, 0)),
      u = r.default.useCallback(function (t) {
        e.set(function (e, t) {
          return _toConsumableArray(e).map(function (e) {
            var n, r, o, l;
            var i = e.target,
              a = String(null !== (r = null === (n = null == i ? void 0 : i.dataset) || void 0 === n ? void 0 : n.key) && void 0 !== r ? r : "");
            return [a, {
              index: String(null !== (l = null === (o = null == i ? void 0 : i.dataset) || void 0 === o ? void 0 : o.index) && void 0 !== l ? l : ""),
              key: a,
              entry: e,
              visible: e.intersectionRatio >= t.ratio
            }];
          });
        }(t, o)), clearTimeout(s.current), s.current = +setTimeout(function () {
          return requestAnimationFrame(function () {
            a(function (t) {
              var n = e.getVisible().map(function (e) {
                return e[1].key;
              });
              return JSON.stringify(t) !== JSON.stringify(n) ? n : t;
            });
          });
        }, o.throttle);
      }, [e, o]);
    return _(function () {
      var e = j(n),
        t = l.current || new IntersectionObserver(u, o);
      return l.current = t, e.forEach(function (e) {
        return t.observe(e);
      }), function () {
        clearTimeout(s.current), t.disconnect(), l.current = void 0;
      };
    }, [u, t, o, n]), {
      visibleElementsWithSeparators: i
    };
  }
  var X = function X(e) {
    return r.default.Children.toArray(e).map(z).filter(Boolean);
  };
  var Y = /*#__PURE__*/function (_Map) {
    _inherits(Y, _Map);
    var _super = _createSuper(Y);
    function Y() {
      _classCallCheck(this, Y);
      return _super.apply(this, arguments);
    }
    _createClass(Y, [{
      key: "toArr",
      value: function toArr() {
        return this.sort(_toConsumableArray(this));
      }
    }, {
      key: "toItems",
      value: function toItems() {
        return this.toArr().map(function (_ref6) {
          var _ref7 = _slicedToArray(_ref6, 1),
            e = _ref7[0];
          return e;
        });
      }
    }, {
      key: "toItemsWithoutSeparators",
      value: function toItemsWithoutSeparators() {
        return P(this.toItems());
      }
    }, {
      key: "toItemsKeys",
      value: function toItemsKeys() {
        return this.toItems();
      }
    }, {
      key: "sort",
      value: function sort(e) {
        return e.sort(function (_ref8, _ref9) {
          var _ref10 = _slicedToArray(_ref8, 2),
            e = _ref10[1];
          var _ref11 = _slicedToArray(_ref9, 2),
            t = _ref11[1];
          return +e.index - +t.index;
        });
      }
    }, {
      key: "set",
      value: function set(e, t) {
        var _this = this;
        return Array.isArray(e) ? this.sort(e).forEach(function (_ref12) {
          var _ref13 = _slicedToArray(_ref12, 2),
            e = _ref13[0],
            t = _ref13[1];
          _get(_getPrototypeOf(Y.prototype), "set", _this).call(_this, String(e), t);
        }) : _get(_getPrototypeOf(Y.prototype), "set", this).call(this, String(e), t), this;
      }
    }, {
      key: "first",
      value: function first() {
        var e;
        return null === (e = this.toArr()[0]) || void 0 === e ? void 0 : e[1];
      }
    }, {
      key: "last",
      value: function last() {
        var e, t;
        return null === (t = null === (e = this.toArr().slice(-1)) || void 0 === e ? void 0 : e[0]) || void 0 === t ? void 0 : t[1];
      }
    }, {
      key: "filter",
      value: function filter(e) {
        return this.toArr().filter(e);
      }
    }, {
      key: "find",
      value: function find(e) {
        return this.toArr().find(e);
      }
    }, {
      key: "findIndex",
      value: function findIndex(e) {
        return this.toArr().findIndex(e);
      }
    }, {
      key: "getCurrentPos",
      value: function getCurrentPos(e, t) {
        var n = this.toArr().filter(function (e) {
            var n;
            return t ? !(null === (n = null == e ? void 0 : e[0]) || void 0 === n ? void 0 : n.includes(l)) : e;
          }),
          r = n.findIndex(function (_ref14) {
            var _ref15 = _slicedToArray(_ref14, 2),
              t = _ref15[0],
              n = _ref15[1];
            return t === e || n === e;
          });
        return [n, r];
      }
    }, {
      key: "prev",
      value: function prev(e, t) {
        var n;
        var _this$getCurrentPos = this.getCurrentPos(e, !!t),
          _this$getCurrentPos2 = _slicedToArray(_this$getCurrentPos, 2),
          r = _this$getCurrentPos2[0],
          o = _this$getCurrentPos2[1];
        return -1 !== o ? null === (n = r[o - 1]) || void 0 === n ? void 0 : n[1] : void 0;
      }
    }, {
      key: "next",
      value: function next(e, t) {
        var n;
        var _this$getCurrentPos3 = this.getCurrentPos(e, !!t),
          _this$getCurrentPos4 = _slicedToArray(_this$getCurrentPos3, 2),
          r = _this$getCurrentPos4[0],
          o = _this$getCurrentPos4[1];
        return -1 !== o ? null === (n = r[o + 1]) || void 0 === n ? void 0 : n[1] : void 0;
      }
    }, {
      key: "getVisible",
      value: function getVisible() {
        return this.filter(function (e) {
          return e[1].visible;
        });
      }
    }, {
      key: "getVisibleElements",
      value: function getVisibleElements() {
        return this.filter(function (e) {
          return !e[0].includes(l) && e[1].visible;
        });
      }
    }]);
    return Y;
  }( /*#__PURE__*/_wrapNativeSuper(Map));
  var q = {
    ratio: .9,
    rootMargin: "5px",
    threshold: [.05, .5, .75, .95],
    throttle: 100
  };
  var J = r.default.createContext({}),
    U = function U(e) {
      return e.reduce(function (e, t) {
        return e.concat(t).concat("".concat(t).concat(l));
      }, []).slice(0, -1);
    };
  e.ScrollMenu = function (_ref16) {
    var e = _ref16.LeftArrow,
      t = _ref16.RightArrow,
      n = _ref16.children,
      o = _ref16.Header,
      i = _ref16.Footer,
      _ref16$transitionDura = _ref16.transitionDuration,
      a = _ref16$transitionDura === void 0 ? 500 : _ref16$transitionDura,
      s = _ref16.transitionEase,
      h = _ref16.transitionBehavior,
      _ref16$onInit = _ref16.onInit,
      p = _ref16$onInit === void 0 ? function () {} : _ref16$onInit,
      _ref16$onUpdate = _ref16.onUpdate,
      g = _ref16$onUpdate === void 0 ? function () {} : _ref16$onUpdate,
      b = _ref16.onMouseDown,
      w = _ref16.onMouseUp,
      E = _ref16.onMouseMove,
      _ref16$onScroll = _ref16.onScroll,
      x = _ref16$onScroll === void 0 ? function () {} : _ref16$onScroll,
      _ref16$onWheel = _ref16.onWheel,
      C = _ref16$onWheel === void 0 ? function () {} : _ref16$onWheel,
      _ref16$options = _ref16.options,
      I = _ref16$options === void 0 ? q : _ref16$options,
      _ref16$scrollContaine = _ref16.scrollContainerClassName,
      N = _ref16$scrollContaine === void 0 ? "" : _ref16$scrollContaine,
      _ref16$itemClassName = _ref16.itemClassName,
      S = _ref16$itemClassName === void 0 ? "" : _ref16$itemClassName,
      _ref16$separatorClass = _ref16.separatorClassName,
      M = _ref16$separatorClass === void 0 ? "" : _ref16$separatorClass,
      _ref16$wrapperClassNa = _ref16.wrapperClassName,
      $ = _ref16$wrapperClassNa === void 0 ? "" : _ref16$wrapperClassNa,
      _ref16$apiRef = _ref16.apiRef,
      W = _ref16$apiRef === void 0 ? {
        current: {}
      } : _ref16$apiRef,
      k = _ref16.RTL,
      O = _ref16.noPolyfill;
    var T = L(e),
      V = L(t),
      R = L(o),
      j = L(i),
      z = r.default.useRef(null),
      _r$default$useState3 = r.default.useState({}),
      _r$default$useState4 = _slicedToArray(_r$default$useState3, 1),
      _ = _r$default$useState4[0],
      U = r.default.useMemo(function () {
        return Object.assign(Object.assign(Object.assign({}, q), I), {
          root: z.current
        });
      }, [I, z.current]),
      K = r.default.useRef(new Y()).current,
      G = function (e, t) {
        var _r$default$useState7 = r.default.useState(""),
          _r$default$useState8 = _slicedToArray(_r$default$useState7, 2),
          n = _r$default$useState8[0],
          o = _r$default$useState8[1],
          i = r.default.useMemo(function () {
            return X(e);
          }, [e]);
        return r.default.useEffect(function () {
          var e = i.filter(Boolean).join("");
          t.toItemsWithoutSeparators().filter(function (e) {
            return !i.includes(e);
          }).forEach(function (e) {
            var n, r;
            var o = (null === (n = t.last()) || void 0 === n ? void 0 : n.key) === e && (null === (r = t.prev(e)) || void 0 === r ? void 0 : r.key) || "";
            t.delete(o), t.delete("".concat(e).concat(l)), t.delete(e);
          }), o(e);
        }, [i, t]), n;
      }(n, K),
      _F = F({
        items: K,
        itemsChanged: G,
        options: U,
        refs: _
      }),
      Q = _F.visibleElementsWithSeparators,
      Z = !!Q.length,
      ee = r.default.useMemo(function () {
        return function (e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          var n = arguments.length > 2 ? arguments[2] : undefined;
          var r = arguments.length > 3 ? arguments[3] : undefined;
          var o = arguments.length > 4 ? arguments[4] : undefined;
          var l = arguments.length > 5 ? arguments[5] : undefined;
          var i, a;
          var s = P(t),
            u = !!(null === (i = e.first()) || void 0 === i ? void 0 : i.visible),
            d = !!(null === (a = e.last()) || void 0 === a ? void 0 : a.visible),
            c = function c(t) {
              var n;
              return null === (n = e.find(function (e) {
                return e[1].key === String(t);
              })) || void 0 === n ? void 0 : n[1];
            },
            f = function f() {
              var t, n;
              return e.prev(null === (n = null === (t = e.getVisible()) || void 0 === t ? void 0 : t[0]) || void 0 === n ? void 0 : n[1]);
            },
            v = function v() {
              var t, n, r, o;
              return e.next(null === (o = null === (r = null === (n = null === (t = e.getVisible()) || void 0 === t ? void 0 : t.slice) || void 0 === n ? void 0 : n.call(t, -1)) || void 0 === r ? void 0 : r[0]) || void 0 === o ? void 0 : o[1]);
            };
          return {
            getItemById: c,
            getItemElementById: B,
            getItemByIndex: function getItemByIndex(t) {
              var n;
              return null === (n = e.find(function (e) {
                return String(e[1].index) === String(t);
              })) || void 0 === n ? void 0 : n[1];
            },
            getItemElementByIndex: H,
            getNextItem: v,
            getNextElement: function getNextElement() {
              var t, n, r, o;
              return e.next(null === (o = null === (r = null === (n = null === (t = e.getVisibleElements()) || void 0 === t ? void 0 : t.slice) || void 0 === n ? void 0 : n.call(t, -1)) || void 0 === r ? void 0 : r[0]) || void 0 === o ? void 0 : o[1], !0);
            },
            getPrevItem: f,
            getPrevElement: function getPrevElement() {
              var t, n;
              return e.prev(null === (n = null === (t = e.getVisibleElements()) || void 0 === t ? void 0 : t[0]) || void 0 === n ? void 0 : n[1], !0);
            },
            isFirstItemVisible: u,
            isItemVisible: function isItemVisible(e) {
              return s.includes(String(e));
            },
            isLastItem: function isLastItem(t) {
              return e.last() === c(t);
            },
            isLastItemVisible: d,
            scrollNext: function scrollNext(e, t, i) {
              var _ref17 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
                a = _ref17.duration,
                s = _ref17.ease,
                _ref17$boundary = _ref17.boundary,
                u = _ref17$boundary === void 0 ? null == n ? void 0 : n.current : _ref17$boundary;
              var d = null != e ? e : null == r ? void 0 : r.behavior;
              return A(v(), d, t || "start", i || "nearest", {
                boundary: u,
                duration: null != a ? a : null == r ? void 0 : r.duration,
                ease: null != s ? s : null == r ? void 0 : r.ease
              }, o || l);
            },
            scrollPrev: function scrollPrev(e, t, i) {
              var _ref18 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
                a = _ref18.duration,
                s = _ref18.ease,
                _ref18$boundary = _ref18.boundary,
                u = _ref18$boundary === void 0 ? null == n ? void 0 : n.current : _ref18$boundary;
              var d = null != e ? e : null == r ? void 0 : r.behavior;
              return A(f(), d, t || "end", i || "nearest", {
                boundary: u,
                duration: null != a ? a : null == r ? void 0 : r.duration,
                ease: null != s ? s : null == r ? void 0 : r.ease
              }, o || l);
            },
            scrollToItem: function scrollToItem(e, t, o, l, i) {
              var a, s;
              return A(e, null != t ? t : null == r ? void 0 : r.behavior, o, l, Object.assign(Object.assign({
                boundary: null == n ? void 0 : n.current
              }, i), {
                duration: null !== (a = null == i ? void 0 : i.duration) && void 0 !== a ? a : null == r ? void 0 : r.duration,
                ease: null !== (s = null == i ? void 0 : i.ease) && void 0 !== s ? s : null == r ? void 0 : r.ease
              }));
            },
            visibleElements: s,
            visibleElementsWithSeparators: t,
            visibleItems: t,
            visibleItemsWithoutSeparators: s
          };
        }(K, Q, z, {
          duration: a,
          ease: s,
          behavior: h
        }, k, O);
      }, [K, Q, G, k, O]),
      te = r.default.useCallback(function () {
        return Object.assign(Object.assign({}, ee), {
          initComplete: Z,
          items: K,
          visibleElementsWithSeparators: Q,
          scrollContainer: z
        });
      }, [ee, Z, K, Q, z]),
      _r$default$useState5 = r.default.useState(te),
      _r$default$useState6 = _slicedToArray(_r$default$useState5, 2),
      ne = _r$default$useState6[0],
      re = _r$default$useState6[1];
    !function (_ref19) {
      var _ref19$cb = _ref19.cb,
        e = _ref19$cb === void 0 ? function () {} : _ref19$cb,
        t = _ref19.condition,
        n = _ref19.hash;
      r.default.useEffect(function () {
        t && e();
      }, [n, t]);
    }({
      cb: function cb() {
        return g(ne);
      },
      condition: function (_ref20) {
        var e = _ref20.cb,
          t = _ref20.condition;
        var _r$default$useState9 = r.default.useState(!1),
          _r$default$useState10 = _slicedToArray(_r$default$useState9, 2),
          n = _r$default$useState10[0],
          o = _r$default$useState10[1];
        return r.default.useEffect(function () {
          t && !n && (o(!0), e());
        }, [t, n]), n;
      }({
        cb: function cb() {
          return p(ne);
        },
        condition: Z
      }),
      hash: JSON.stringify(Q.concat(String(null == ne ? void 0 : ne.isFirstItemVisible)).concat(String(null == ne ? void 0 : ne.isLastItemVisible)))
    }), r.default.useEffect(function () {
      return re(te());
    }, [te]), W.current = ne;
    var oe = r.default.useCallback(function (e) {
        return x(ne, e);
      }, [x, ne]),
      le = r.default.useCallback(function (e) {
        return C(ne, e);
      }, [C, ne]),
      ie = r.default.useMemo(function () {
        return "".concat(u, " ").concat($);
      }, [$]),
      ae = r.default.useMemo(function () {
        return "".concat(N).concat(k ? " rtl" : "");
      }, [k, N]);
    return r.default.createElement("div", {
      className: ie,
      onWheel: le,
      onMouseDown: null == b ? void 0 : b(ne),
      onMouseUp: null == w ? void 0 : w(ne),
      onMouseMove: null == E ? void 0 : E(ne)
    }, r.default.createElement(J.Provider, {
      value: ne
    }, r.default.createElement("div", {
      className: c
    }, R), r.default.createElement("div", {
      className: d
    }, r.default.createElement("div", {
      className: f
    }, T), r.default.createElement(y, {
      className: ae,
      onScroll: oe,
      scrollRef: z
    }, r.default.createElement(D, {
      refs: _,
      itemClassName: S,
      separatorClassName: M
    }, n)), r.default.createElement("div", {
      className: v
    }, V)), r.default.createElement("div", {
      className: m
    }, j)));
  }, e.VisibilityContext = J, e.constants = b, e.getItemsPos = function (e) {
    var t;
    var n = function (e) {
        return e.filter(function (e, t, n) {
          var r = 0 === t,
            o = t === n.length - 1,
            i = new RegExp(l).test(e);
          return !((r || o) && i);
        });
      }(e),
      r = n[Math.floor(n.length / 2)];
    return {
      first: null == n ? void 0 : n[0],
      center: r,
      last: null === (t = n.slice(-1)) || void 0 === t ? void 0 : t[0]
    };
  }, e.slidingWindow = function (e, t) {
    var n = P(e),
      r = P(t);
    return {
      prev: function prev() {
        return U(function (e, t) {
          var n = e.findIndex(function (e) {
              return e === (null == t ? void 0 : t[0]);
            }),
            r = t.length,
            o = n - r,
            l = o < 0,
            i = l ? 0 : o,
            a = e.slice(i, l ? r : n);
          return a.length === r ? a : e.slice(n, r);
        }(n, r));
      },
      next: function next() {
        return U(function (e, t) {
          var n = e.findIndex(function (e) {
              var n;
              return e === (null === (n = t.slice(-1)) || void 0 === n ? void 0 : n[0]);
            }),
            r = t.length,
            o = n + r + 1,
            l = o > e.length - 1,
            i = l ? e.length - 1 : o,
            a = e.slice(l ? i - r + 1 : n + 1, i);
          return a.length === r ? a : e.slice(e.length - r, e.length + r);
        }(n, r));
      }
    };
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});